// extracted by mini-css-extract-plugin
module.exports = {"SocialNetworks":"SocialNetworks_SocialNetworks__v2AYU"};